export const opportunityPricingSkus = (skus, opportunity) => {
  const selectedFeatureIds = new Set([
    ...(Array.isArray(opportunity?.featureIds) ? opportunity.featureIds : []),
    ...(Array.isArray(opportunity?.features)
      ? opportunity.features.map((feature) => feature?.id)
      : []),
  ].filter(Boolean).map(String));
  return (skus || []).filter(
    (sku) => !sku.featureId || selectedFeatureIds.has(String(sku.featureId)),
  );
};

const DEFAULT_PRICING_SKU_CODES = new Set(['SETUP']);

export const opportunityPricingGroups = (skus, opportunity) => {
  const groups = { defaults: [], features: [], extras: [] };

  opportunityPricingSkus(skus, opportunity).forEach((sku) => {
    if (DEFAULT_PRICING_SKU_CODES.has(String(sku.code))) {
      groups.defaults.push(sku);
    } else if (sku.featureId) {
      groups.features.push(sku);
    } else {
      groups.extras.push(sku);
    }
  });

  return groups;
};
